import script from "./TvPlusMobileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TvPlusMobileModal.vue?vue&type=script&setup=true&lang=js"

import "./TvPlusMobileModal.vue?vue&type=style&index=0&id=abb7f6dc&lang=scss"

const __exports__ = script;

export default __exports__